/**
 * 
 * @typedef BoardStateDto
 * @export BoardStateDto
 * @class BoardStateDto
 */
module.exports= class BoardStateDto {
    /**
     * Creates an instance of BoardStateDto.
     * @param {Array} layout 
     * @param {Array} capturedPlayer2KomaList 
     * @param {Array} capturedPlayer1KomaList 
     * @param {String} playerSide 
     * 
     * @memberOf BoardStateDto
     */
    constructor(layout,capturedPlayer2KomaList,capturedPlayer1KomaList,playerSide){
      this.layout=layout;
      this.capturedPlayer2KomaList=capturedPlayer2KomaList;
      this.capturedPlayer1KomaList=capturedPlayer1KomaList;
      this.playerSide=playerSide;
    }
}